import { Switch as BaseSwitch } from "antd"
import React from "react"

export function Switch(props: React.ComponentProps<typeof BaseSwitch>) {
    return <BaseSwitch {...props} />
}
